import { getSystemConfig } from '@/api/system'

const state = {
  config: null,
  loaded: false,
  loading: false
}

const mutations = {
  SET_CONFIG: (state, config) => {
    state.config = config
    state.loaded = true
  },
  SET_LOADING: (state, loading) => {
    state.loading = loading
  },
  RESET_CONFIG: (state) => {
    state.config = null
    state.loaded = false
    state.loading = false
  }
}

const actions = {
  // 获取系统配置
  fetchConfig({ commit, state }) {
    // 如果已经加载过，直接返回
    if (state.loaded) {
      return Promise.resolve(state.config)
    }

    // 如果正在加载，等待加载完成
    if (state.loading) {
      return new Promise((resolve) => {
        const checkInterval = setInterval(() => {
          if (state.loaded) {
            clearInterval(checkInterval)
            resolve(state.config)
          }
        }, 100)
      })
    }

    commit('SET_LOADING', true)
    return new Promise((resolve, reject) => {
      getSystemConfig()
        .then(response => {
          const config = response.data || response
          commit('SET_CONFIG', config)
          commit('SET_LOADING', false)
          resolve(config)
        })
        .catch(error => {
          commit('SET_LOADING', false)
          reject(error)
        })
    })
  },

  // 重置配置
  resetConfig({ commit }) {
    commit('RESET_CONFIG')
  }
}

const getters = {
  config: state => state.config,
  configLoaded: state => state.loaded,
  configLoading: state => state.loading
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

